<div class="card section">
  <div class="card-body">
    <div class="d-flex flex-row justify-content-between align-items-center">
      <div class="d-flex flex-row align-items-center">
        <div class="pr-4">
          <h6>{{ number ?? "#" }}</h6>
        </div>
        <div class="pl-2 pr-3">
          <mat-label
            [innerHTML]="
              labelHtml || 'Select one:' | placeholderHighlight: editor
            "
          ></mat-label>
        </div>
        <mat-radio-group
          class="d-flex flex-row flex-wrap align-items-center"
          [value]="selectedOption?.id"
        >
          <mat-radio-button
            class="mr-3"
            *ngFor="let option of statusOptions"
            [value]="option.id"
            [disabled]="checkDisabled() || editor"
            (change)="setStatus(option)"
          >
            {{ option.label }}
          </mat-radio-button>
        </mat-radio-group>
        <mat-icon
          color="warn"
          *ngIf="!statusOptions.length && !editor"
          matTooltip="No status change options configured"
          matTooltipClass="warn-tooltip"
          >warning</mat-icon
        >
      </div>
      <mat-checkbox-with-roles
        [labelPosition]="'before'"
        [checked]="checked"
        [disabled]="true"
        [color]="color"
        [roleCodes]="roleCodes"
        [user]="user"
        [date]="date"
      ></mat-checkbox-with-roles>
    </div>
  </div>
</div>
